import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Col,
	Nav,
	NavItem,
	NavLink,
	TabContent,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import FiltertRightbar from "./FiltersRightbar";

import {
	getRFQListcount,
	getRFQRequestList,
	SetParams,
	FiltersShowRightSidebar,
	FilterClear,
} from "../../store/RequetForQuotation/actions";

import "./RequestForQuotation.scss";
import AllRequestForQuotation from "./AllRequestForQuotation";
import LoadingModel from "../LoadingModel";

class RequestForQuotationDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = { FilterToggle: false };
		this.toggleTab = this.toggleTab.bind(this);
	}

	//>>>>>>>>>>>>>>>>>>>>>
	componentDidMount() {
		this.props.FilterClear();
		this.props.getRFQListcount();
		this.props.getRFQRequestList({
			...this.props.params,
			rfqstatus: [0],
			search: "",
			start_date: "",
			end_date: "",
			userdepartment: "",
			department: "",
		});

		this.props.SetParams({
			...this.props.params,
			rfqstatus: [0],
			search: "",
			start_date: "",
			end_date: "",
			userdepartment: "",
			department: "",
		});
	}

	toggleTab(tab) {
		var rfqstatus = [0];
		if (tab === 1) {
			rfqstatus = [0];
		} else if (tab !== 2) {
			if (tab === 3) {
				rfqstatus = [5];
			} else if (tab === 4) {
				rfqstatus = [3];
			} else if (tab === 5) {
				rfqstatus = [4];
			}
		} else if (tab === 2) {
			rfqstatus = [1, 2];
		}
		this.props.getRFQRequestList({
			...this.props.params,
			rfqstatus: rfqstatus,
			page: 1,
		});

		this.props.SetParams({
			...this.props.params,
			rfqstatus: rfqstatus,
			page: 1,
		});
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}

						<Row>
							<Col lg={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom ">
										<h5 className="card-title-18 pt-2 d-inline-block">
											Request For Quotation Dashboard
										</h5>
										<div className="float-right">
											<div className="d-inline-block">
												<Button
													type="button"
													color="light"
													className="waves-effect waves-light d-flex  mr-2"
													onClick={() =>
														this.props.FiltersShowRightSidebar()
													}>
													<i className="mdi mdi-filter"></i>
													<span className="d-none d-lg-block ml-1">
														Filters
													</span>
												</Button>
											</div>

											<Button
												type="button"
												color="primary"
												className="waves-effect waves-light"
												href="/newrfq/0">
												New RFQ
											</Button>
										</div>
									</CardHeader>
									<CardBody className="pt-0">
										<Nav tabs className="nav-tabs-custom ">
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(1);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.rfqstatus[0] ===
																0,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													All |{" "}
													<span>
														{
															this.props
																.rfqListCount
																?.all_count
														}{" "}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(2);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.rfqstatus[0] ===
																1,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													Open |{" "}
													<span>
														{
															this.props
																.rfqListCount
																?.open_count
														}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(3);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.rfqstatus[0] ===
																5,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													Compare Quotation |{" "}
													<span>
														{
															this.props
																.rfqListCount
																?.comparequotation
														}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(4);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.rfqstatus[0] ===
																3,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													PO in Prograss |{" "}
													<span>
														{
															this.props
																.rfqListCount
																?.poinprograss_count
														}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(5);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.rfqstatus[0] ===
																4,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													Close |{" "}
													<span>
														{
															this.props
																.rfqListCount
																?.close_count
														}
													</span>
												</NavLink>
											</NavItem>
										</Nav>
										<TabContent>
											<AllRequestForQuotation />
										</TabContent>
									</CardBody>
								</Card>
							</Col>
						</Row>
						<FiltertRightbar />
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { params, filterdata, loading, rfqListCount } =
		state.RequestForQuotation;
	return {
		params,
		filterdata,
		loading,
		rfqListCount,
	};
};

export default connect(mapStatetoProps, {
	getRFQListcount,
	getRFQRequestList,
	SetParams,
	FiltersShowRightSidebar,
	FilterClear,
})(RequestForQuotationDashboard);
